const STORAGE_KEY = "cr:discovered-features";

/**
 * Tracks whether a user has discovered/dismissed a feature hint.
 * Backed by localStorage so it persists across sessions.
 */
export function useFeatureDiscovery(featureId: string) {
    const dismissed = ref(false);

    onMounted(() => {
        try {
            const raw = localStorage.getItem(STORAGE_KEY);
            const map: Record<string, boolean> = raw ? JSON.parse(raw) : {};
            dismissed.value = !!map[featureId];
        } catch {
            dismissed.value = false;
        }
    });

    function dismiss() {
        dismissed.value = true;
        try {
            const raw = localStorage.getItem(STORAGE_KEY);
            const map: Record<string, boolean> = raw ? JSON.parse(raw) : {};
            map[featureId] = true;
            localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
        } catch {
            // localStorage unavailable — silently ignore
        }
    }

    return { dismissed, dismiss };
}
